/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */


export const Reporting = r => require.ensure([], () => 
                                r(require('../components/list/reporting')), 'report-bundle')

export const RepeatAffender = r => require.ensure([], () => 
                                r(require('../components/list/repeatAffender.vue')), 'report-bundle')

export const campaignReporting = r => require.ensure([], () => 
                                r(require('../components/list/campaign_reporting')), 'report-bundle')

export const recipientListing = r => require.ensure([], () => 
                                r(require('../components/list/recipient_listing')), 'report-bundle')

/*
export const recipientProfile = r => require.ensure([], () => 
                                r(require('../components/list/recipient_profile')), 'report-bundle')
 */
 
/*
export const createCampaignMain = r => require.ensure([], () => 
                                r(require('../components/main')), 'campaign-bundle')
 */



// WEBPACK FOOTER //
// ./src/app/report/routes/components.js